import { useState } from "react";
import { useDispatch } from "react-redux";
import { Navigate, NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import AuthLayout from "../../components/layouts/AuthLayout";
// import ActionCreator from "../../utils/helpers/actionCreator";
// import { setLoggedInUser } from "../../store/actions/auth.action";
// import TenantService from "../../utils/services/profile.service";
import { 
	// InputValidator, 
	Loading, MenuType, SubMenuType } from "../../utils/helpers/constants";
// import * as AuthConstants from "../../store/constants/auth.constants";
// import PasswordValidator from "../../components/form/PasswordValidator";
// import {
// 	emailValidator,
// 	phoneValidator,
// 	passwordMatchValidator,
// 	validateIfInteger
// } from "../../utils/services/validator.service";
import TokenHelper from "../../utils/helpers/tokenHelper";
// import PasswordInput from "../../components/form/PasswordInput";
import ProfileService from "../../utils/services/profile.service";
import { getProfile } from "../../store/actions/profile.action";

const RegisterSocialOrganisation = () => {
	const dispatch = useDispatch(), navigate = useNavigate(), isLoggedIn = TokenHelper.checkIfLoggedIn(), onboardingStatus = TokenHelper.getOnboardingStatus();
	// const [firstName, setFirstName] = useState("");
	// const [lastName, setLastName] = useState("");
	// const [password, setPassword] = useState("");
	// const [confirmPassword, setConfirmPassword] = useState("");
	const [organisationName, setOrganisationName] = useState("");
	const [organisationType, setOrganisationType] = useState("");
	// const [phone, setPhone] = useState({ value: "", errorState: false });
	const [email,] = useState({ value: "", errorState: false });
	const [loading, setLoadingStatus] = useState(false);
	const [agreedTerms, setAgreedTerms] = useState(false);
	// const [passwordError, setPasswordError] = useState(false);
	// const [passwordConfirmError, setConfirmPasswordError] = useState(false);

	const ifValidated = !agreedTerms || !organisationType || !organisationName || !organisationName === ""  ;

	// const handleFieldValidation = (data, type) => {
	// 	if (type === 'EMAIL') {
	// 		const validatedEmail = emailValidator(data);
	// 		setEmail(prev => ({ ...prev, value: validatedEmail.validateEmail }));
	// 		validatedEmail.validState === InputValidator.VALID ? setEmail(prev => ({ ...prev, errorState: false })) : setEmail(prev => ({ ...prev, errorState: true }));
	// 	} else if (type === 'PHONE') {
	// 		data = data.replace(/[^0-9/+]/gi, "");
	// 		const validatedPhone = phoneValidator(data);
	// 		setPhone(prev => ({ ...prev, value: data }));
	// 		validatedPhone === InputValidator.VALID ? setPhone(prev => ({ ...prev, errorState: false })) : setPhone(prev => ({ ...prev, errorState: true }));
	// 	} else if (type === 'PASSWORD' || type === 'CONFIRM_PASSWORD') {
	// 		const validatedConfirmPassword = passwordMatchValidator(password, data);
	// 		type === 'PASSWORD' ? setPassword(data) : setConfirmPassword(data);
	// 		if (validatedConfirmPassword === InputValidator.VALID) {
	// 			setPasswordError(false);
	// 			setConfirmPasswordError(false);
	// 		} else {
	// 			setPasswordError(true);
	// 			setConfirmPasswordError(true);
	// 		}
	// 	}
	// }

	// const handleRegistration = async () => {
	// 	setLoadingStatus(true);
	// 	const payload = {
	// 		email: email.value.toLowerCase(),
	// 		phone: phone.value,
	// 		password,
	// 		country: "NGA",
	// 		name: organisationName,
	// 		org_flow: organisationType,
	// 		first_name: firstName, last_name: lastName, confirm_password: confirmPassword,
	// 	};
	// 	const { data: responseData } = await TenantService.registerTenant(payload);
	// 	setLoadingStatus(false);
	// 	if (responseData.status !== Loading.SUCCESS) toast.error(responseData.message)
	// 	else {
	// 		dispatch(ActionCreator(AuthConstants.LOGIN_SUCCESS, true));
	// 		await dispatch(setLoggedInUser(responseData.data.access));
	// 		navigate('/');
	// 	}
	// }

	const handleCreateNewOrg = async () => {
		setLoadingStatus(true);
		const payload = { name: organisationName, country: "NGA", org_flow: organisationType };
		const { data: responseData } = await ProfileService.createOrganisation(payload);
		if (responseData.status !== Loading.SUCCESS) toast.error(responseData.message);
		else {
		TokenHelper.saveSelectedOrg(responseData.data.reference);
		TokenHelper.saveUserRole("Admin");
		TokenHelper.saveSelectedOrgCountry(responseData.data['supported_country']);
		TokenHelper.saveOnboardingStatus('PENDING');
		await dispatch(getProfile());
		toast.success("Organisation created: sign up complete");
		navigate(`/`);
		}
		setLoadingStatus(false);
  	};

	if (isLoggedIn && onboardingStatus !== 'NON_ORGANISATION') return <Navigate to={{ pathname: "/" }} />;

	return (
		<AuthLayout>
			<div className="card">
				<div className="row row-sm">
					<div className="col-lg-1 d-none d-lg-block bg-primary bg-custom" />
					<div className="col-lg-11  col-xs-12 col-sm-12 login_form ">
						<div className="container-fluid">
							<div className="row row-sm">
								<div className="card-body m-0">
									<div>
										<h5 className="text-start mb-0">Complete Your Account</h5>
										<p className="mb-4 text-muted tx-13 ms-0 text-start">
											Create an account for your organisation to get started with Siju By truQ. Please fill in the details below to complete your registration.
										</p>
									</div>
									<form>
										<div className="row">
											<div className="col-12 mb-3">
												<div className="form-group text-start mb-0">
													<label className="mb-0">Organisation Name</label>
													<input className="form-control" onChange={e => setOrganisationName(e.target.value)}
														placeholder="e.g truQ Dynamic Services" type="text" />
												</div>
											</div>
										</div>
										{/* <div className="row">
											<div className="col-sm-6 mb-3">
												<div className="form-group text-start mb-0">
													<label className="mb-0">First Name</label>
													<input className="form-control" onChange={e => setFirstName(e.target.value)}
														placeholder="e.g Chiroma" type="text" />
												</div>
											</div>
											<div className="col-sm-6 mb-3">
												<div className="form-group text-start mb-0">
													<label className="mb-0">Last Name</label>
													<input className="form-control" onChange={e => setLastName(e.target.value)}
														placeholder="e.g Adenike" type="text" />
												</div>
											</div>
										</div> */}

										<div className="row">
											<div className="col-sm-12 mb-3">
												<div className="form-group text-start mb-0">
													<label className="mb-0">Email</label>
													<input disabled={true} className={`form-control ${(email && email.errorState) && 'is-invalid'}`}
														value={email.value}
														onChange={event => null}
														placeholder="e.g example@eg.com" type="tel" />
													{(email && email.errorState) &&
														<small className="text-danger">Please enter a valid email address (e.g test@abc.com).</small>
													}
												</div>
											</div>

											{/* <div className="col-sm-6 mb-3">
												<div className="form-group text-start mb-0">
													<label className="mb-0">Phone</label>
													<input className={`form-control ${(phone && phone.errorState) && 'is-invalid'}`} type="number"
														value={phone.value}
														onKeyPress={validateIfInteger}
														onChange={event => handleFieldValidation(event.target.value, 'PHONE')}
														placeholder="e.g +2348100000000" />
													{(phone && phone.errorState) &&
														<small className="text-danger">Please enter a valid phone number.</small>}
												</div>
											</div> */}
										</div>
										{/* <div className="row">
											<div className="col-sm-6 mb-3">
												<PasswordInput label="Password" passwordError={passwordError} name="password" placeholder="********" value={password} updatePassword={value => handleFieldValidation(value, 'PASSWORD')} />
											</div>
											<div className="col-sm-6 mb-3">
												<PasswordInput label="Confirm Password" passwordError={passwordConfirmError} name="confirm_Password" placeholder="********" value={confirmPassword} updatePassword={value => handleFieldValidation(value, 'CONFIRM_PASSWORD')} />
											</div>
											{(passwordError || passwordConfirmError) ?
												<div className="mb-4">
													<PasswordValidator value={password} />
													<span className="password-validator-wrapper text-start">
														<p className={`${(password === confirmPassword) ? "valid" : "invalid"}`}>
															Password and Confirm Password does not match
														</p>
													</span>
												</div> : null
											}
										</div> */}

										<div className="text-start my-3">
											<div className="mb-4">
												<h5 className="mb-1">What kind of business do you own?</h5>
												<p>Please select the category that best describes your business:</p>
											</div>
											<div className="form-group">
												<label className="custom-switch form-switch mb-0 p-0">
													<input type="radio" name="custom-switch-radio" className="custom-switch-input"
														value="DEMAND_FLOW"
														onClick={e => setOrganisationType(e.target.value)} />
													<span className="custom-switch-indicator"></span>
													<span className="custom-switch-description">
														&nbsp;Demand-Based Business.
													</span>
												</label>
												<span className="form-label d-block mb-4">
													I require logistics services for my business operations and do not own any vehicles.
												</span>


												<label className="custom-switch form-switch mb-0 p-0">
													<input type="radio" name="custom-switch-radio" className="custom-switch-input"
														value="SUPPLY_FLOW"
														onClick={e => setOrganisationType(e.target.value)} />
													<span className="custom-switch-indicator"></span>
													<span className="custom-switch-description">
														&nbsp;Supply-Based Business.
													</span>
												</label>
												<span className="form-label d-block mb-4">
													I own vehicles and provide logistics services to other businesses.
												</span>


												<label className="custom-switch form-switch mb-0 p-0">
													<input type="radio" name="custom-switch-radio" className="custom-switch-input"
														value="DEMAND_SUPPLY_FLOW"
														onClick={e => setOrganisationType(e.target.value)} />
													<span className="custom-switch-indicator"></span>
													<span className="custom-switch-description">
														&nbsp;Demand and Supply Business.
													</span>
												</label>
												<span className="form-label d-block">
													I require logistics services and own vehicles for my business operations.
												</span>
											</div>
										</div>

										<div className="row mt-4">
											<div className="col-1 mt-3">
												<div className="form-group text-start ms-1">
													<label className="ckbox">
														<input type="checkbox" className="form-check-input" checked={agreedTerms}
															onChange={() => setAgreedTerms(!agreedTerms)} />
														<span className="tx-14 ms-3"></span>
													</label>
												</div>
											</div>
											<div className="col-11 mt-3 text-start">
												<span className="tx-14">
													&nbsp;I consent to the collection and processing of my personal data in line with data regulations as described in
													<a href="https://www.mytruq.com/legal/privacy-policy" target="_blank"
														rel="noopener noreferrer" className="fs-14">&nbsp;Siju By truQ's Privacy Policy</a>.
												</span>
											</div>
										</div>

										<button className="btn ripple btn-main-primary btn-block mt-4" type="button"
											disabled={ifValidated} onClick={()=> handleCreateNewOrg()}>
											Complete Sign up{loading ? <>&nbsp;<i className="fa fa-spin fa-spinner" /> </> : ""}
										</button>
									</form>

									<div className="mt-4">
										By clicking the “Sign Up” button, you agree to Siju By truQ’s
										<br />
										<a href="https://www.mytruq.com/legal/terms-conditions" target="_blank" rel="noopener noreferrer">
											terms of acceptable use.
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="mt-2 text-center">Already have an account?<NavLink to={`/${MenuType.AUTH}/${SubMenuType.LOGIN}`}> Sign In</NavLink>
			</div>
		</AuthLayout>
	)
}

export default RegisterSocialOrganisation;
